import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { UPDATE_DYNAMIC_LIST_ENDPOINT } from 'api/ListsApi';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { ApiError, ApiResponse, post } from 'services/api';

import { useListDetailsContext } from '../contexts/listDetails';
import { useModalsContext } from '../contexts/modals';
import { UpdateDynamicListParams, UpdateDynamicListSuccessResponse } from '../types';
import { useTranslation } from '.';

const updateDynamicListMutation = (params: UpdateDynamicListParams) =>
  post(UPDATE_DYNAMIC_LIST_ENDPOINT, params);

export const useUpdateDynamicListMutation = () => {
  const { t } = useTranslation();
  const dispatchHook = useDispatch();
  const { list } = useListDetailsContext();
  const { hideModal: closeModal } = useModalsContext();

  const onSuccess = () => {
    // Note: API returns "Successfully updated list ID [emailListId]"
    dispatchHook(addPositiveToast(t('toast.updateDynamic.positive', { listName: list.name })));
    closeModal();
  };

  const onError = (resp: ApiError) => {
    const errorType =
      resp?.response?.data?.error || t('toast.updateDynamic.negative.errTypGeneric');
    const errorMessage =
      resp?.response?.data?.message || t('toast.updateDynamic.negative.errMsgGeneric');
    const errorMsg = `${errorType}: ${errorMessage}`;
    dispatchHook(addNegativeToast(t('toast.updateDynamic.negative.message', { errorMsg })));
  };

  return useMutation<
    ApiResponse<UpdateDynamicListSuccessResponse>,
    ApiError,
    UpdateDynamicListParams
  >({
    mutationFn: updateDynamicListMutation,
    onSuccess,
    onError,
  });
};
